module.exports = __webpack_public_path__ + "img/search.42bb5bf6.png";